import { useCallback, useEffect, useState } from "react";
import { io } from "socket.io-client";
import { getPortfolioSummary } from "@/lib/api";

const SOCKET_URL = process.env.REACT_APP_BACKEND_URL;

// Single source of truth for the combined paper portfolio (equity + per-section
// open-position counts). Subscribes to Socket.IO account_update + a 30s poll.
export const usePortfolioSummary = () => {
  const [data, setData] = useState(null);

  const load = useCallback(async () => {
    try { setData(await getPortfolioSummary()); } catch { /* ignore */ }
  }, []);

  useEffect(() => {
    load();
    const socket = io(SOCKET_URL, { path: "/api/socketio", transports: ["polling", "websocket"],
      auth: { token: localStorage.getItem("oracle_token") || "" } });
    socket.on("account_update", () => load());
    const poll = setInterval(load, 30000);
    return () => { socket.disconnect(); clearInterval(poll); };
  }, [load]);

  return data;
};
